const home = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.303%202.585l9.477%209.477-1.413%201.413L19.89%2012v8a2%202%200%200%201-2%202h-12a2%202%200%200%201-2-2v-8.002l-1.477%201.477L1%2012.062l9.477-9.477c.78-.78%202.046-.78%202.826%200zM11.89%204l-6.002%206h.002v10h12V10h.001L11.89%203.999z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  home as default
};
//# sourceMappingURL=home.svg.es.js.map
